import { render, staticRenderFns } from "./subscriptionBookkeep.vue?vue&type=template&id=1b56e07f&scoped=true"
import script from "./subscriptionBookkeep.vue?vue&type=script&lang=js"
export * from "./subscriptionBookkeep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b56e07f",
  null
  
)

export default component.exports